import { ComponentIds, PlacementResult } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import { ProductType } from '@inter-ikea-storageone/range';

const autoFillHandlesBehavior = ({ coreApi, props }: BehaviorParameters) => {
  const fronts = coreApi.entities.getByProductTypes([
    ProductType.KNOXHULT_DOOR_FRONT,
    ProductType.KNOXHULT_DRAWER_FRONT
  ]);

  const placementResults = fronts.map(front => {
    const handle = coreApi.entities.getDescendantsWithComponent(
      front,
      ComponentIds.HANDLE_COMPONENT_ID
    );
    if (handle.length > 0) {
      coreApi.entities.deleteMultiple(handle);
    }
    return coreApi.products.addToTarget(props.coreProductId, front);
  });

  placementResults.forEach((result: PlacementResult) => {
    if (!result.valid && result.errors && result.errors.length > 0) {
      coreApi.entities.disposeCollidingEntities(result.errors);
    }
  });
};

export default autoFillHandlesBehavior;
